import styled from "styled-components";
export const ItemMask0 = styled.div `
  background-color: ${({ theme }) => theme.color.ui7};
  height: 16px;
  margin: auto;
  -webkit-mask-image: url(${({ $mask }) => $mask});
  mask-image: url(${({ $mask }) => $mask});
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  width: 16px;
`;
export const ItemMask1 = styled.div `
  background-color: ${({ theme }) => theme.color.s1};
  height: 16px;
  -webkit-mask-image: url(${({ $mask }) => $mask});
  mask-image: url(${({ $mask }) => $mask});
  -webkit-mask-position: ${({ $position }) => $position !== null && $position !== void 0 ? $position : "center"};
  mask-position: ${({ $position }) => $position !== null && $position !== void 0 ? $position : "center"};
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: ${({ $size }) => $size !== null && $size !== void 0 ? $size : "100%"};
  mask-size: ${({ $size }) => $size !== null && $size !== void 0 ? $size : "100%"};
  width: 16px;
`;
